import { FormSchemaApplicantDetails } from "../ApplicantDetails/types";
import { FormSchemaExpenditure } from "./types";
import { setDataForApi } from "utils/api";

const parseApplicantExpenditure = (applicant: any) => {
  if (!applicant) {
    return applicant;
  }

  const { creditProviders } = applicant;

  if (creditProviders) {
    creditProviders.forEach((cp: any) => {
      setDataForApi(cp);
    });
  }

  setDataForApi(applicant);

  return applicant;
};

const parseDataForApi = (
  data: FormSchemaExpenditure,
  _numberOfApplicants: number,
  applicantsFieldArray: Array<FormSchemaApplicantDetails>,
) => {
  if (!data) {
    return data;
  }

  (data?.applicantCredit || [])?.map((applicant, i) => {
    parseApplicantExpenditure(applicant);
    if (!applicant.applicantId) {
      applicant.applicantId = applicantsFieldArray[i].uuid;
    }
    return applicant;
  });

  setDataForApi(data?.householdExpenditure);
  setDataForApi(data);

  return data;
};

export default parseDataForApi;
